import React from "react";

/**
 * DirectorShell — shared structural layout for every Director-tier
 * operational page (Director Centre, Mission Control, Automations,
 * Revenue Command, and any future /director/* sub-route).
 *
 * Strictly a layout container. Owns:
 *   • Desktop offset past the fixed left sidebar (`md:ml-[var(--cf-sidebar-w,300px)] transition-[margin-left] duration-300 ease-out`).
 *   • `min-w-0` so internal flex/grid children can shrink instead of
 *     forcing their parent wider than the viewport.
 *   • `overflow-x-hidden` so any single wide child (chart canvas,
 *     long pill row, table) cannot push horizontal scroll into the
 *     sidebar.
 *   • Full viewport height via `min-h-screen` so the gp-surface
 *     background paints to the bottom of every screen.
 *
 * Does NOT own:
 *   • Internal padding rhythm   (pages manage their own gutters).
 *   • Background colour          (`gp-surface` lives on the body —
 *                                 pages already inherit it).
 *   • Sidebar mounting           (PersistentShell in App.js mounts
 *                                 the global Sidebar instance).
 *
 * Usage:
 *   <DirectorShell testid="mission-control-page">
 *     <div className="px-5 sm:px-7 lg:px-9 pt-6 pb-12">
 *       …page content…
 *     </div>
 *   </DirectorShell>
 */
export const DirectorShell = ({ children, testid, className = "", embedded = false }) => (
  <div
    className={`${embedded ? "min-w-0" : "md:ml-[var(--cf-sidebar-w,300px)] transition-[margin-left] duration-300 ease-out min-h-screen min-w-0 overflow-x-hidden"} ${className}`.trim()}
    data-testid={testid}
  >
    {children}
  </div>
);

export default DirectorShell;
